module.exports = __webpack_public_path__ + "static/media/profile-tick.75ba238c.svg";